import React from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import { ITraining } from '../../../../../../domains/Training';

import {
  Center,
  DashedLine,
  DocTitle,
  ExerciseItem,
  FieldRow,
  Footer,
  GymName,
  Receipt,
  Sheet,
} from './styles';

interface IReceiptPrintProps {
  gymName?: string;
  studentName: string;
  splitLabel: string;
  trainings: ITraining[];
  lastEditedByName?: string | null;
}

const sanitizeNumber = (value: unknown): number | undefined => {
  if (typeof value !== 'number' || Number.isNaN(value)) return undefined;
  return value;
};

const formatRange = (
  minInput?: number | null,
  maxInput?: number | null,
  suffix = '',
): string => {
  const min = sanitizeNumber(minInput);
  const max = sanitizeNumber(maxInput);

  if (min === undefined && max === undefined) return '-';
  if (max === undefined || min === max) return `${min}${suffix}`;
  return `${min}-${max}${suffix}`;
};

const ReceiptPrint: React.FC<IReceiptPrintProps> = ({
  gymName,
  studentName,
  splitLabel,
  trainings,
  lastEditedByName,
}) => {
  return (
    <Sheet className="print-sheet">
      <Receipt>
        <Center>
          <GymName>{gymName || 'TrenzoX'}</GymName>
          <DocTitle>FICHA DE TREINO</DocTitle>
        </Center>

        <DashedLine />

        <FieldRow>
          <span>ALUNO</span>
          <span>{studentName}</span>
        </FieldRow>
        <FieldRow>
          <span>SPLIT</span>
          <span>{splitLabel}</span>
        </FieldRow>
        <FieldRow>
          <span>DATA</span>
          <span>
            {format(new Date(), 'dd/MM/yyyy HH:mm', { locale: ptBR })}
          </span>
        </FieldRow>
        {!!lastEditedByName && (
          <FieldRow>
            <span>MONTADO POR</span>
            <span>{lastEditedByName}</span>
          </FieldRow>
        )}

        <DashedLine />

        {trainings.map((training, index) => (
          <ExerciseItem key={training.id}>
            <strong>
              {index + 1}. {training.exercise.name}
            </strong>
            <span>
              {formatRange(training.sets_min, training.sets_max)} SERIES x{' '}
              {formatRange(training.reps_min, training.reps_max)} REPS
              {' | '}
              DESCANSO{' '}
              {formatRange(training.interval_min, training.interval_max, 's')}
              {sanitizeNumber(training.weight) !== undefined && (
                <>
                  {' | '}
                  CARGA {training.weight}KG
                </>
              )}
            </span>
          </ExerciseItem>
        ))}

        <DashedLine />

        <Footer>Gerado por TrenzoX. Treino marcado como concluido</Footer>
      </Receipt>
    </Sheet>
  );
};

export { ReceiptPrint };
